export const ROLES = {
  admin: 'ADMIN',
  employee: 'EMPLOYEE',
  dev: 'DEVELOPER'
}

export const SCOPES = {
  canViewReport: 'can-view-report',
  canViewCOReports: 'can-view-co-reports',
  canViewMainReport: 'can-view-main-report'
}

export const PERMISSIONS = {
  [ROLES.admin]: [SCOPES.canViewReport, SCOPES.canViewCOReports, SCOPES.canViewMainReport],
  [ROLES.employee]: [SCOPES.canViewReport],
  [ROLES.dev]: [SCOPES.canViewMainReport, SCOPES.canViewReport, SCOPES.canViewCOReports]
}